import { plural } from './format';
import type { Messages } from './messages';

// DE: Ukrainische Oberflächentexte.
// EN: Ukrainian UI texts.
export const uk: Messages = {
  tabToday: 'Сьогодні',
  tabPlan: 'План',
  tabShopping: 'Покупки',
  settings: 'Налаштування',
  defaultMemberNames: ['Я', 'Партнер'],
  shoppingTitle: 'Покупки',
  shoppingToday: 'Так, сьогодні йдемо в магазин',
  shoppingExtra: 'Сьогодні треба докупити',
  nothingToBuy: 'Сьогодні нічого купувати не треба',
  shopsClosedToday: 'Сьогодні магазини зачинені',
  nextTrip: (date, stores, total) => `Наступний похід: ${date} · ${stores} · ≈ ${total}`,
  itemCount: (count) =>
    `${count} ${plural('uk', count, { one: 'продукт', few: 'продукти', many: 'продуктів', other: 'продукту' })}`,
  total: (total) => `Разом ${total}`,
  totalWithWine: (total, wine) => `Разом ${total}, з них вино ${wine}`,
  openShoppingList: 'Відкрити список покупок',
  amongShopping: 'Серед покупок',
  dinnerTitle: 'Вечеря',
  minutes: (count) => `${count} хв`,
  activeMinutes: (count) => `з них ${count} хв біля плити`,
  portions: (count) =>
    `${count} ${plural('uk', count, { one: 'порція', few: 'порції', many: 'порцій', other: 'порції' })}: вечеря + обід із собою`,
  fish: 'риба',
  addOn: (member, product, amount) => `${member}: + ${product} ${amount}`,
  allAtHome: 'Усе вже вдома',
  recipe: 'Рецепт',
  noEnergy: 'Нема сил',
  tomorrowTitle: 'Завтра',
  holidayTomorrow: (holiday) => `Завтра ${holiday}: магазини зачинені`,
  noPlanTitle: 'Плану ще немає',
  planMonth: 'План до кінця місяця',
  planWeek: 'План на тиждень',
  planEnds: (date) => `Останній день плану: ${date}`,
  nextMonth: 'План на наступний місяць',
  nextWeek: 'План на наступний тиждень',
  planning: 'Складаю план…',
  chooseFederalState: 'Оберіть федеральну землю в налаштуваннях, щоб урахувати свята.',
  close: 'Закрити',
  ingredients: 'Продукти',
  steps: 'Приготування',
  noEnergyTitle: 'Щось швидке замість цього',
  noEnergyHint: 'Спершу страви з того, що є вдома.',
  noAlternatives: 'Швидких страв зараз немає.',
  movedTo: (date) => `Заплановану страву перенесено: ${date}.`,
  useSoon: (products) => `Використайте найближчими днями: ${products}.`,
  planAgain: 'Скласти заново',
  planAgainQuestion: 'Скласти заново всі незафіксовані дні від сьогодні?',
  yes: 'Так',
  cancel: 'Скасувати',
  budgetPlanned: (planned, limit) => `Заплановано ${planned} з ${limit}`,
  wholePlan: 'Увесь план',
  thisWeek: 'Цей тиждень',
  weekOf: (date, cost) => `Тиждень з ${date} · ${cost}`,
  nextPlanTitle: 'Наступний план',
  quick: 'швидко',
  lunchbox: 'обід із собою',
  locked: 'зафіксовано',
  breakfast: 'Сніданок',
  lunch: 'Обід',
  replace: 'Замінити',
  replaceTitle: 'Чим замінити',
  noReplacement: 'Інших страв для цього дня немає.',
  perPortion: (price) => `${price} за порцію`,
  lock: 'Зафіксувати',
  unlock: 'Відкріпити',
  lowEnergyDay: 'Цього дня буде мало сил',
  lowEnergyMarked: 'Цього дня заплановано щось швидке.',
  relaxedWarnings: {
    'relaxed-quick': 'Швидкої страви не знайшлося, тож обрано довшу.',
    'relaxed-lunchbox': 'Страва не дуже підходить для обіду з собою.',
    'relaxed-variety': 'Страва повторюється раніше, ніж через тиждень.',
  },
  overBudget: (amount) => `План дорожчий за бюджет на ${amount}.`,
  checkAtHome: (products) => `Магазини зачинені. Перевірте, чи є вдома: ${products}.`,
  markBought: 'Купили',
  doneTrips: 'Зроблені покупки',
  allBought: 'Усі покупки зроблено.',
  onOffer: 'акція',
  savings: (amount) => `Знижки: ${amount}`,
  categories: {
    veg: 'Овочі й фрукти',
    meat: 'Мʼясо й риба',
    dairy: 'Молочне й яйця',
    grain: 'Хліб, крупи, макарони',
    canned: 'Консерви',
    frozen: 'Заморожене',
    basics: 'Основні продукти',
    drinks: 'Напої',
  },
  languageTitle: 'Мова',
  appearanceTitle: 'Вигляд',
  appearanceChoices: { system: 'Як на телефоні', light: 'Світла', dark: 'Темна' },
  installHint:
    'Додайте застосунок на початковий екран: «Поділитися» → «На початковий екран». Так дані не зітруться.',
  installHintDismiss: 'Зрозуміло',
  federalStateTitle: 'Федеральна земля',
  federalStateHint: 'Від неї залежать свята, коли магазини зачинені.',
  notChosen: 'Не вибрано',
  closedDaysTitle: 'Власні вихідні дні',
  closedDaysHint: 'Дні без походу в магазин, наприклад місцеве свято.',
  addClosedDay: 'Додати',
  remove: 'Видалити',
  noClosedDays: 'Поки немає.',
  backupTitle: 'Резервна копія',
  backupHint: 'Дані зберігаються лише на цьому телефоні. Збережіть копію у файл.',
  downloadBackup: 'Зберегти у файл',
  restoreBackup: 'Відновити з файлу',
  restoreQuestion: 'Замінити всі дані на цьому телефоні даними з файлу?',
  restored: 'Дані відновлено.',
  backupErrors: {
    invalid: 'Файл не схожий на резервну копію цього застосунку.',
    'newer-version': 'Файл з новішої версії застосунку. Спершу оновіть застосунок.',
  },
  errorTitle: 'Щось пішло не так',
  errorText:
    'Застосунок не може показати збережені дані. Збережіть їх у файл, а потім почніть заново: копія лишиться на телефоні.',
  errorSave: 'Зберегти дані у файл',
  errorRestart: 'Почати заново',
  holidays: {
    'new-year': 'Новий рік',
    epiphany: 'Богоявлення',
    'womens-day': 'Міжнародний жіночий день',
    'good-friday': 'Страсна п’ятниця',
    'easter-monday': 'Великодній понеділок',
    'labour-day': 'День праці',
    ascension: 'Вознесіння',
    'whit-monday': 'Понеділок Трійці',
    'corpus-christi': 'Свято Тіла і Крові Христових',
    assumption: 'Успіння Богородиці',
    'world-childrens-day': 'Всесвітній день дітей',
    'unity-day': 'День німецької єдності',
    'reformation-day': 'День Реформації',
    'all-saints': 'День усіх святих',
    'repentance-day': 'День покаяння та молитви',
    'christmas-day': 'Різдво',
    'boxing-day': 'Другий день Різдва',
  },
  states: {
    BW: 'Баден-Вюртемберг',
    BY: 'Баварія',
    BE: 'Берлін',
    BB: 'Бранденбург',
    HB: 'Бремен',
    HH: 'Гамбург',
    HE: 'Гессен',
    MV: 'Мекленбург — Передня Померанія',
    NI: 'Нижня Саксонія',
    NW: 'Північний Рейн — Вестфалія',
    RP: 'Рейнланд-Пфальц',
    SL: 'Саар',
    SN: 'Саксонія',
    ST: 'Саксонія-Ангальт',
    SH: 'Шлезвіг-Гольштейн',
    TH: 'Тюрингія',
  },
};
